import CreateItemButton from "components/buttons/create";
import { List } from "components";
import { PermissionControlledInput } from "permissions/components/input";
import React from "react";
import { useParams } from "react-router-dom";
import { DateCell } from "@/components/date/cell";
import { useJob } from "@/modules/work/jobs/context";
import HeaderPortal from "components/portal/header-portal";
import { StatusDisplay } from "@/components/status/display";
import ExtentionBanner from "./components/banner";

const StatusCell = ({ getValue }) => {
  const value = getValue();
  return value ? <StatusDisplay value={value} /> : "—";
};

export default function JobsExtensions() {
  const { jobId } = useParams();

  const fields = [
    "id",
    "end_date",
    "start_date",
    "justification",
    "date_created",
    "category.id",
    "category.label",
    "reason.id",
    "reason.label",
    "status",
  ];

  const columns = [
    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
      cell: DateCell,
    },
    {
      id: "end_date",
      header: "End Date",
      accessorKey: "end_date",
      cell: DateCell,
    },
    {
      id: "category",
      header: "Category",
      accessorKey: "category.label",
    },
    {
      id: "reason",
      header: "Reason",
      accessorKey: "reason.label",
    },
    {
      id: "justification",
      header: "Justification",
      accessorKey: "justification",
      sortable: false,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
      sortable: false,
    },
    {
      id: "date_created",
      header: "Created",
      accessorKey: "date_created",
      cell: DateCell,
    },
  ];

  const defaultFilters = {
    job: {
      id: {
        _eq: jobId,
      },
    },
  };

  return (
    <div className="p-2 flex-1 overflow-auto">

      {/* {type === "fixed" || type === "bucket" ? ( */}
      <HeaderPortal>
        <PermissionControlledInput
          rule="create:JC,AM"
          collection="job_extensions"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Extension</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      {/* ) : <ExtentionBanner />} */}
      <List
        title="Extensions"
        storageKey={jobId}
        endPoint="job_extensions"
        filters={defaultFilters}
        columns={columns}
        meta={{ fields }}
        // hidePagination={true}
        showSearch={false}
        href={(row) => row.id}
      // onRowClick={(row) => navigate(`${row.id}`)}
      />
    </div>
  );
}
